import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import VideoShowcase from "@/components/VideoShowcase";
import WhyGoaSetu from "@/components/WhyGoaSetu";
import OpportunityExchange from "@/components/OpportunityExchange";
import SplitAudience from "@/components/SplitAudience";
import DealFlow from "@/components/DealFlow";
import Trust from "@/components/Trust";
import GlobalShowcase from "@/components/GlobalShowcase";
import LeadForms from "@/components/LeadForms";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import Admin from "@/pages/Admin";

const HomePage = () => (
  <main className="App gs-noise relative" data-testid="home-page">
    <Navigation />
    <Hero />
    <VideoShowcase />
    <WhyGoaSetu />
    <OpportunityExchange />
    <SplitAudience />
    <DealFlow />
    <Trust />
    <GlobalShowcase />
    <LeadForms />
    <FinalCTA />
    <Footer />
  </main>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
